module.exports = __webpack_public_path__ + "img/s2P5.ca8e092a.png";